var Component = require("!../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../vue-loader/lib/selector?type=script&index=0!./VueLazyBackgroundImage.vue"),
  /* template */
  require("!!../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6c5be9a6\"}!../vue-loader/lib/selector?type=template&index=0!./VueLazyBackgroundImage.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-lazy-background-images/VueLazyBackgroundImage.vue
// module id = 1
// module chunks = 0